export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/dfffdcc654f425d556d7485c2bf841db.svg";